import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      day: '',
      hour: '',
      minute: '',
    };

    this.handleFieldChange = handleFieldChange.bind(this);
    this.handleCheckboxChange = handleCheckboxChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit() {
    const isValid = this.validateForm();
    const filters = Object.assign({}, this.state);

    if(isValid) this.props.onSubmit(filters);
  }

  validateForm() {
    const { day } = this.state;

    let alert = null;

    if(!day) alert = 'Please set Day';

    this.setState({ alert });

    return !alert;
  }

  getAlert() {
    const { alert } = this.state;

    if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
  }

  render() {
    return (
        <form>
          {this.getAlert()}
          <Row>
            <Col lg={2}>
              <FieldGroup
                  type="date"
                  name="day"
                  label="Day:"
                  onChange={this.handleFieldChange}
                  value={this.state.day}
              />
            </Col>
            <Col lg={2}>
              <FieldGroup
                  type="number"
                  name="hour"
                  label="Hour:"
                  min={0}
                  max={23}
                  onChange={this.handleFieldChange}
                  value={this.state.hour}
              />
            </Col>
            <Col lg={2}>
              <SelectWrap
                  values={[ 0, 15, 30, 45 ]}
                  label="Minute:"
                  name="minute"
                  onChange={this.handleFieldChange}
                  value={this.state.minute}
                  required
              />
            </Col>
            <Col lg={4}>
              <SelectWrap
                  value={this.state.source}
                  name="source"
                  label="Source:"
                  values={this.props.sources}
                  onChange={this.handleFieldChange}
                  multi
                  required
              />
            </Col>
          </Row>

          <ButtonGroup>
            <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Load</Button>
          </ButtonGroup>
        </form>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesGraph/components/Form/index.js